/**
 * User: Faris
 * Date: 5/24/13
 * Time: 3:49 PM
 */

define('app/site',['require','./utils','../gen/templates','../gen/views','./router','./collections/Content_areas','./views/baseview','./views/preloader'],function(require){

  //global requires
  require('./utils');
  require('../gen/templates');
  require('../gen/views');

  //utilities
  var Router = require('./router');
  var Content_areas = require('./collections/Content_areas');

  //global views
  var BaseView = require('./views/baseview');
  var Preloader = require('./views/preloader');

  return Backbone.View.extend({

    contentContainer: null,
    pages: null,
    pageViews: [],
    activePageView: null,

    events: {
      'click a[href]:ajax-link, a[data-href]:ajax-link': 'onClickLink',
      'click #mobile-nav-toggle': 'onClickMobileNavToggle'
    },

    initialize: function(options){
      Backbone.View.prototype.initialize.call(options);

      _.bindAll(this,
        'onClickLink',
        'onClickMobileNavToggle',
        'onRouteChanged',
        'onPageLoaded',
        'onResize',
        'onScroll',
        'onMouseWheel'
      );

      //backbone dom setup
      this.setElement($('body'));
      this.initViews(this.$el);
      this.contentContainer = $('#content');

      //bootstrapped pages
      this.pages = new Content_areas();
      this.pages.reset(window.PAGES);

      //global views
      this.preloader = new Preloader({ el: '#PreloaderContainer' });

      //routing
      this.router = new Router();
      this.router.on('route:catchall', this.onRouteChanged);
      Backbone.history.start({ pushState:true });

      //window events
      $(window).resize(_.throttle(this.onResize, 100));
      $(window).scroll(_.throttle(this.onScroll, 100));

      if($.browser.win) {
        $(window).on('mousewheel', this.onMouseWheel);
      }

      TweenMax.to('#wrapper', 1, { alpha: 1 });
      TweenMax.to('#site-loader', 0.5, { alpha: 0, display: 'none' });

      _.defer(function(){
        $(window).resize().scroll();
      });
    },

    initViews: function(el){
      $('[data-view]', el).each(function(){
        if($(this).data().instance == null) {
          var View = window.iws.viewManager.get($(this).data('view'));
          if(View){
            var view = new View({ el: $(this) });
            view.preload();
          }
        } else {
          console.log('view already instantiated: ', this);
          return;
        }
      });
    },

    getActivePageView: function(){
      return this.activePageView;
    },

    setActivePageView: function(pageView){
      this.$el.removeClass().addClass(pageView.view);
      this.contentContainer.append(pageView.$el);
      this.activePageView = pageView;
      this.updateActiveNav(pageView.model);
      $(window).scrollTop(0).resize();
    },

    getPageByID: function(id){
      var page = this.pages.get(id);
      if(page){
        return page;
      } else {
        console.log('could not find page by id: ' + path);
        return false;
      }
    },

    getPageByPath: function(path){
      var page = this.pages.findWhere({ PATH: path });
      if(page){
        return page;
      } else {
        console.log('could not find page by path: ' + path);
        return false;
      }
    },

    updateActiveNav: function(model){
      $('a').removeClass('active');
      var active = $('a[data-id="' + model.id + '"]');
      while(active.length){
        active.addClass('active');
        active = $('a[data-id="' + active.data().parentid + '"]');
      }
    },

    onClickLink: function(e){
      this.$el.removeClass('nav-expanded');
      var href = $(e.currentTarget).attr('href') || $(e.currentTarget).data('href');
      this.router.navigate(href, { trigger:true });
      e.preventDefault();
      return false;
    },

    onRouteChanged: function(url){
      var path = '/' + (url || '');
      var page = this.getPageByPath(path);

      if(ga){
        ga('send', 'pageview', path);
      }

      if(page){
        if(page.get('loaded')){
          var cachedView = this.pageViews[page.id];
          if(cachedView == this.activePageView){
            this.activePageView.reset();
            return;
          }

          if(cachedView){
            window.iws.flowManager.goto(cachedView, this.activePageView);
          }
        } else {
          page.fetch({ success: this.onPageLoaded });
        }
      } else {
        this.router.navigate('/', { trigger: true });
      }
    },

    onPageLoaded: function(model){
      var PageView = window.iws.viewManager.get(model.get('TEMPLATE'));
      if(PageView){
        //create view instance
        var view = new PageView({ model: model });
        view.render();

        //cache pageview for later use
        this.pageViews[model.id] = view;

        window.iws.flowManager.goto(view, this.activePageView);
      }
    },

    onResize: function(e){
    },

    onScroll: function(e){
    },

    onMouseWheel: function(e){
      var isSelectTag = $(e.target).prop('tagName').toLowerCase() == 'select';
      var isSelect2Drop = $(e.target).is('.select2-drop') || $(e.target).closest('.select2-drop').length > 0;

      if(!isSelectTag && ! isSelect2Drop) {
        if (!this.$el.hasClass('nav-expanded')) {
          e.preventDefault();
          TweenMax.to(window, 0.3, { scrollTo: { y: e.deltaY > 0 ? '-=100' : '+=100' }, ease: Power2.easeOut });
        }
      }
    },

    onClickMobileNavToggle: function(e){
      this.$el.toggleClass('nav-expanded');
    }

  });

});
